module.exports = __webpack_public_path__ + "static/img/ctimg73.45f0306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctimg73.png
// module id = CAIE
// module chunks = 5